import { type SxProps, type Theme, Typography } from '@mui/material';
import { useSession } from '@side/next-auth/react';
import type { Referral, ReferralSummary } from '@/common/hooks/referrals/types';
import { getTransactionStatusContent } from './helpers';

interface Props {
  referral: ReferralSummary | Referral;
  sx?: SxProps<Theme>;
}

export const TransactionStatus = ({ referral, sx }: Props) => {
  const { id: userId, legacyExternalId } = useSession()?.data?.user ?? {};
  const contactUserId = referral.transactingAgent?.userId;
  const isTransactingAgent =
    contactUserId != null &&
    (contactUserId === userId || contactUserId === legacyExternalId);

  const transactionStatusContent = getTransactionStatusContent({
    referral,
    isTransactingAgent,
  });

  return (
    <Typography
      variant="body2"
      component="span"
      sx={{
        display: 'flex',
        flexGrow: 1,
        color: 'text.secondary',
        ...sx,
      }}
      noWrap
    >
      {transactionStatusContent}
    </Typography>
  );
};
